import React, { useState, useEffect, useRef, useContext } from "react";
import { useAuthContext } from "../context/AuthContext";
import { useCartContext } from "../context/CartContext";
import { useFamilyContext } from "../context/FamilyContext";
import { useAddressContext } from "../context/AddressContext";
import { useOrderProcessingContext } from "../context/OrderProcessingContext";
import { useTestContext } from "../context/TestContext";
import {
	IoIosCloseCircle,
	BiPlus,
	IoIosArrowDroprightCircle,
} from "../utils/Icons";
import {
	getNext7Days,
	calculateAge,
	getCurrentDate,
	getNextDate,
} from "../utils/DateUtils";
import { capitalizeFirstLetter } from "../utils/OtherUtils";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

// Imports
import Navbar from "../components/Navbar";
import NavigationTracker from "../components/NavigationTracker";
import AddMemberPopup from "../components/AddMemberPopup";
import AddAddressPopup from "../components/AddAddressPopup";
import Notification from "../components/Notification";
import PromoCodePopup from "../components/PromoCodePopup";
import CollectionMethodPopup from "../components/CollectionMethodPopup";
import AuthComponent from "../components/AuthComponent";
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';


const pathkindLabsSlot = [
	"7:00 AM - 8:00 AM",
	"8:00 AM - 9:00 AM",
	"9:00 AM - 10:00 AM",
	"10:00 AM - 11:00 AM",
	"11:00 AM - 12:00 PM",
	"12:00 PM - 1:00 PM",
	"1:00 PM - 2:00 PM",
	"2:00 PM - 3:00 PM",
	"3:00 PM - 4:00 PM",
];

const drLalPathlabsSlot = [
	"7:00 AM - 7:30 AM",
	"7:30 AM - 8:00 AM",
	"8:00 AM - 8:30 AM",
	"8:30 AM - 9:00 AM",
	"9:00 AM - 9:30 AM",
	"9:30 AM - 10:00 AM",
	"10:00 AM - 10:30 AM",
	"10:30 AM - 11:00 AM",
	"11:00 AM - 11:30 AM",
	"11:30 AM - 12:00 PM",
	"12:00 PM - 12:30 PM",
	"12:30 PM - 1:00 PM",
	"1:00 PM - 1:30 PM",
	"1:30 PM - 2:00 PM",
];

const redcliffeeLabsSlot = [
	"5 AM - 6 AM",
	"6 AM - 7 AM",
	"7 AM - 8 AM",
	"8 AM - 9 AM",
	"9 AM - 10 AM",
	"10 AM - 11 AM",
	"11 AM - 12 PM",
	"12 PM - 1 PM",
	"1 PM - 2 PM",
	"2 PM - 3 PM",
];

const AgilusSlot = [
	"6:00 AM - 7:00 AM",
	"7:00 AM - 8:00 AM",
	"8:00 AM - 9:00 AM",
	"9:00 AM - 10:00 AM",
	"10:00 AM - 11:00 AM",
	"11:00 AM - 12:00 PM",
	"12:00 PM - 1:00 PM",
	"1:00 PM - 2:00 PM",
	"2:00 PM - 3:00 PM",
	"3:00 PM - 4:00 PM",
	"4:00 PM - 5:00 PM",
	"5:00 PM - 6:00 PM",
];

const metropolisSlot = [
	"7:00 AM - 8:00 AM",
	"8:00 AM - 9:00 AM",
	"9:00 AM - 10:00 AM",
	"10:00 AM - 11:00 AM",
	"11:00 AM - 12:00 PM",
	"12:00 PM - 1:00 PM",
	"1:00 PM - 2:00 PM",
	"2:00 PM - 3:00 PM",
];

const visitCentreSlot = [
	"10:00 AM - 11:00 AM",
	"11:00 AM - 12:00 AM",
	"12:00 AM - 01:00 PM",
	"01:00 PM - 02:00 PM",
	"02:00 PM - 03:00 PM",
	"03:00 PM - 04:00 PM",
	"04:00 PM - 05:00 PM",
	"05:00 PM - 06:00 PM",
	"06:00 PM - 07:00 PM",
];

const convertToDate = (dateObj) => {
	const monthMap = {
		Jan: 0,
		Feb: 1,
		Mar: 2,
		Apr: 3,
		May: 4,
		Jun: 5,
		Jul: 6,
		Aug: 7,
		Sep: 8,
		Oct: 9,
		Nov: 10,
		Dec: 11,
	};

	const { day, month, year } = dateObj;
	const monthIndex = monthMap[month];

	// Return Date object (avoiding timezone issues)
	const date = new Date(Date.UTC(year, monthIndex, day));
	return date;
};

const Cart = () => {
	const [currentPage, setCurrentPage] = useState(0);
	const itemsPerPage = 5;

	const next7DaysArray = getNext7Days();
	const currentDate = getCurrentDate();
	const nextDate = getNextDate();
	const [selectedVisitCenter, setSelectedVisitCenter] = useState("");
	const [selectedSlot, setSelectedSlot] = useState("");
	// const [redcliffeeLabsSlot, setRedcliffeeLabsSlot] = useState([]);

	const { notificationData, isAuth, userLocationAddress } = useAuthContext();
	const { getCart } = useCartContext();
	// const { calculateTotalPrice } = useContext(CartContext);
	const {
		order,
		isProceedEnabled,
		validationError,
		addANewMember,
		setIndexToAddPatient,
		isAddMemberPopup,
		setIsAddMemberPopup,
		removePatientAtIndex,
		removeSpecificProduct,
		isAddAddressPopup,
		setIsAddAddressPopup,
		removeAddress,
		saveCurrentLocation,
		serviceableArea,
		saveCollectionDate,
		saveCollectionTime,
		saveVisitDate,
		saveVisitTime,
		isPromoCode,
		setIsPromoCode,
		handleCreateOrder,
		removePromoCode,
		setAddMoreTestIndex,
		countAllCartProducts,
		handleApplyPromoCode,
		saveVisitCenter,
		calculateTotalPrice,
		fetchCentresByCityAndBrand,
		allCentres,
		collectionType,
		setCollectionType,
		setIsCollectionMethodPopup,
		isCollectionMethodPopup,
		handleServiceableArea,
		setOrder,
		getRedcliffeLabsTimeSlots,
		fetchCentresByCityAndBrandAndType,
		centreAvailable,
		setAllCentres,
		setCentreAvailable,
	} = useOrderProcessingContext();

	const { getMembers } = useFamilyContext();
	const { getAddresses } = useAddressContext();
	const navigate = useNavigate();
	const [visitClicked, setVisitClicked] = useState(false);
	const [isRemoving, setIsRemoving] = useState(false);
	const [cartCollectionType, setCartCollectionType] = useState("");
	const [slotsAreFull, setSlotsAreFull] = useState(false);
	const { orderSummary } = useOrderProcessingContext();
	const [isLoadingRedcliffeLabsSlots, setIsLoadingRedcliffeLabsSlots] =
		useState(false);
	const handleAddMemberPopup = () => {
		setIsAddMemberPopup((prev) => !prev);
	};

	// useEffect(() => {
	//   const fetchData = async () => {
	//     setIsLoadingRedcliffeLabsSlots(true);
	//     const collectionDate = convertToDate(order?.collectionDate.date).toISOString().split('T')[0];
	//     console.log(collectionDate);

	//     const response = await getRedcliffeLabsTimeSlots(collectionDate);
	//     const redcliffeTimeSlots = response.map(slot => ({
	//       id: slot.id,
	//       time: `${slot.format_12_hrs.start_time} - ${slot.format_12_hrs.end_time}`
	//     }));
	//     setRedcliffeeLabsSlot(redcliffeTimeSlots);
	//     setIsLoadingRedcliffeLabsSlots(false);
	//   };
	//   if (order.collectionDate.date && order.orderData[0]  && order.orderData[0].items[0].product.brandName === "Redcliffe Labs") {
	//     fetchData();
	//   }
	// }, [order.collectionDate.date]);

	// useEffect(()=>{
	//     setAllCentres([]);
	//     setCentreAvailable({
	//   flag: null,
	//   message: "",
	// })
	//     removePromoCode();
	// },[])



	const handleRemoveProductClick = (index, idx) => {
		if (isRemoving) return;
		// removeAddress(index, idx);
		setIsRemoving(true);
		removeSpecificProduct(index, idx);
		setIsRemoving(false);
		// removeAddress();
	};

	const handleAddAddressPopup = () => {
		setIsAddAddressPopup((prev) => !prev);
	};

	const handlePromoCodePopup = () => {
		setIsPromoCode((prev) => !prev);
	};

	const handleVisitCenterChange = (e) => {
		setSelectedVisitCenter(e.target.value);
	};

	const handleSlotChange = (e) => {
		setSelectedSlot(e.target.value);
	};



	const handleCollectionType = (getCollectionType) => {
		setCollectionType(getCollectionType);
	};

	const handleCartCollectionType = (getCollectionType) => {
		setCartCollectionType(getCollectionType);
	};

	useEffect(() => {
		if (collectionType === "Visit") {
			setVisitClicked(true);
		}
		handleCartCollectionType(collectionType);
	}, [collectionType]);

	const handleChangeMethodClick = () => {
		setIsCollectionMethodPopup(true);
	};

	useEffect(() => {
		const token = Cookies.get("token");
		const userId = Cookies.get("userId");

		if (token && userId) {
			getCart();
			getMembers();
			getAddresses();
		}
	}, [getCart]);

	useEffect(() => {
		if (!serviceableArea.flag) {
			setCollectionType("Visit");
		}
	}, [serviceableArea.flag]);

	// Getting brandName
	const brandNameInCart =
		order?.orderData[order?.orderData?.length - 1]?.items[
			order?.orderData[order?.orderData?.length - 1]?.items?.length - 1
		]?.product?.brandName;

	// console.log("brandNameInCart", brandNameInCart);

	// useEffect(() => {
	// 	// clear slot/date selection if brand changed
	// 	setSelectedSlot(null);
	// 	// setSelectedDate(null);
	// }, [brandNameInCart]);

	// Getting city
	const city = order?.address?.city || "";

	// Checking if any productType is Radiology
	const hasRadiology = order?.orderData?.some((orderItem) =>
		orderItem.items.some((item) => item.product?.productType === "Radiology")
	);

	//Check if any productType other thatn Radiology
	const hasOtherThanRadiology = order?.orderData?.some((orderItem) =>
		orderItem.items.some((item) => item.product?.productType !== "Radiology")
	);

	// Getting all products in the cart
	const allProductsInCart = order.orderData.flatMap((orderItem) =>
		orderItem.items.map((item) => item.product)
	);

	useEffect(() => {
		if (order?.appliedPromoCode?.length > 0) {
			handleApplyPromoCode();
		}
	}, [countAllCartProducts()]);


	// --------------this is define the type only for dr lal------------------
	// useEffect(() => {
	// 	if (!order) return;
	// 	handleServiceableArea(order);
	// 	if (city && brandNameInCart) {
	// 		if (brandNameInCart === "Dr Lal PathLabs") {
	// 			const type = [
	// 				...new Set(
	// 					order?.orderData?.[0]?.items
	// 						?.map((item) => item.product?.productType)
	// 						.filter(Boolean)
	// 				),
	// 			];
	// 			// console.log("Type of products in cart:", type);
	// 			fetchCentresByCityAndBrandAndType("Dr Lal PathLabs", city, type);
	// 		} else {
	// 			fetchCentresByCityAndBrand(brandNameInCart, city);
	// 			console.log("Brand name in cart", brandNameInCart);
	// 			console.log("City in cart", city);
	// 			fetchCentresByCityAndBrandAndType(brandNameInCart, city, []);
	// 			console.log("Type of products in cart:", []);
	// 			console.log("Brand name in cart LINE 356", brandNameInCart);
	// 		}
	// 	}
	// }, [order, brandNameInCart]);

	// --------------------------THis is define the type of for all brand---------------
	useEffect(() => {
		if (!order) return;
		handleServiceableArea(order);

		if (city && brandNameInCart) {
			// Always extract type from order items
			const type = [
				...new Set(
					order?.orderData?.[0]?.items
						?.map((item) => item.product?.productType)
						.filter(Boolean)
				),
			];

			// Now call API for all brands
			fetchCentresByCityAndBrandAndType(brandNameInCart, city, type);
		}
	}, [order, brandNameInCart]);

	// console.log("product type", product?.productType);

	useEffect(() => {
		if (hasRadiology && hasOtherThanRadiology) {
			setIsCollectionMethodPopup(false);
		}
		if (hasRadiology && !hasOtherThanRadiology) {
			setCollectionType("Visit");
		}
	}, []);

	useEffect(() => {
		// Check if order.collectionDate exists and has a date property
		if (order.collectionDate && order.collectionDate.date) {
			const collectionDateExists = next7DaysArray.some(
				(dateObj) =>
					dateObj.day === order.collectionDate.date.day &&
					dateObj.month === order.collectionDate.date.month &&
					dateObj.year === order.collectionDate.date.year
			);

			if (!collectionDateExists) {
				// Set collection date to empty
				setOrder((prevOrder) => ({
					...prevOrder,
					collectionDate: {},
				}));
			}
		}

		// Check if order.visitDate exists and has a date property
		if (order.visitDate && order.visitDate.date) {
			const visitDateExists = next7DaysArray.some(
				(dateObj) =>
					dateObj.day === order.visitDate.date.day &&
					dateObj.month === order.visitDate.date.month &&
					dateObj.year === order.visitDate.date.year
			);

			if (!visitDateExists) {
				// Set visit date to empty
				setOrder((prevOrder) => ({
					...prevOrder,
					visitDate: {},
				}));
			}
		}
	}, [next7DaysArray, order.collectionDate, order.visitDate]);

	// console.log("order data", order?.orderData?.length)
	const isValidOrder =
		Object.keys(order?.address ?? {}).length > 0 &&
		Object.keys(order?.orderData[order?.orderData?.length - 1]?.patient ?? {})
			.length > 0 &&
		order?.orderData[0]?.patient?.name &&
		order?.orderData[0]?.patient?.dob &&
		order?.orderData[0]?.patient?.gender &&
		// Standard cases when there's no mixed radiology/non-radiology situation
		(((!hasRadiology || !hasOtherThanRadiology) &&
			// Then check the usual conditions
			((collectionType === "Home" &&
				order?.collectionDate?.date?.day &&
				order?.collectionDate?.date?.dayName?.length > 0 &&
				order?.collectionDate?.date?.month?.length > 0 &&
				order?.collectionDate?.time?.length > 0) ||
				(collectionType === "Visit" &&
					order?.visitCenter &&
					order?.visitDate?.date?.day &&
					order?.visitDate?.date?.dayName?.length > 0 &&
					order?.visitDate?.date?.month?.length > 0 &&
					order?.visitDate?.time?.length > 0))) ||
			// Special case when we have both radiology and non-radiology
			(hasRadiology &&
				hasOtherThanRadiology &&
				// We need BOTH visitDate and collectionDate to be valid
				order?.visitCenter &&
				order?.visitDate?.date?.day &&
				order?.visitDate?.date?.dayName?.length > 0 &&
				order?.visitDate?.date?.month?.length > 0 &&
				order?.visitDate?.time?.length > 0 &&
				// Also check collection date for Home collection
				(collectionType !== "Home" ||
					(order?.collectionDate?.date?.day &&
						order?.collectionDate?.date?.dayName?.length > 0 &&
						order?.collectionDate?.date?.month?.length > 0 &&
						order?.collectionDate?.time?.length > 0))));

	useEffect(() => {
		let intervalId;

		const checkTime = () => {
			const now = new Date();
			const hour = now.getHours();

			if (hour >= 20) {
				if (order.collectionDate?.date && currentDate) {
					const isNextDay =
						currentDate.day + 1 === order.collectionDate.date.day &&
						currentDate.month === order.collectionDate.date.month &&
						currentDate.year === order.collectionDate.date.year;

					if (isNextDay) {
						setOrder((prevOrder) => ({
							...prevOrder,
							collectionDate: {},
						}));
						setSlotsAreFull(true);
					} else {
						setSlotsAreFull(false);
					}
				}

				if (intervalId) clearInterval(intervalId);
			}
		};

		const now = new Date();
		const hour = now.getHours();
		const minute = now.getMinutes();

		checkTime();

		//  Start interval only if it's 7:58 or 7:59
		if (hour === 19 && minute >= 50 && minute < 60) {
			intervalId = setInterval(checkTime, 60000); // check every minute
		}

		// Cleanup
		return () => {
			if (intervalId) clearInterval(intervalId);
		};
	}, [order, currentDate]);

	const gpsRef = useRef();

	useEffect(() => {
		if (userLocationAddress === "") {
			gpsRef.current?.scrollIntoView({ behavior: "smooth" });
		}
	}, []);

	const [isLoading, setIsLoading] = useState(false);

	const startAnimation = () => {
		setIsLoading(true);
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve();
			}, 500);
		});
	};

	const resetAnimation = () => {
		return new Promise((resolve) => {
			setIsLoading(false);
			setTimeout(() => {
				resolve();
			}, 500);
		});
	};

	// const handleProceedToPaymentClick = async () => {
	// 	await startAnimation();
	// 	// console.log("Proceed to payment clicked", order);
	// 	await handleCreateOrder();
	// 	await resetAnimation();
	// 	setTimeout(() => {
	// 		window.location.reload(true);

	// 	}, 3000)
	// };



	const handleProceedToPaymentClick = async () => {
		const permission = await navigator.permissions.query({ name: "geolocation" });

		// if (permission.state !== "granted") {
		// 	alert(
		// 		" Location permission denied.\n\n" +
		// 		" Please enable location access manually:\n" +
		// 		"- Click the lock icon 🔒 in the address bar\n" +
		// 		"- Set Location to Allow\n" +
		// 		"- Reload the page"
		// 	);
		// 	return;
		// }

		// continue
		await startAnimation();
		await handleCreateOrder();
		await resetAnimation();

		// setTimeout(() => {
		// 	window.location.reload(true);
		// }, 3000);
	};


	const [showAll, setShowAll] = useState(false);
	const displayedCentres = showAll ? allCentres : allCentres.slice(0, 5);

	useEffect(() => {
		// run only when cart is empty
		if (countAllCartProducts() === 0) {
			removeAddress();
			// prevent infinite reload loop
			if (!sessionStorage.getItem("cartReloaded")) {
				sessionStorage.setItem("cartReloaded", "true");

				window.location.reload();
			}

		} else {
			// if cart has items again → clear flag
			sessionStorage.removeItem("cartReloaded");
		}
	}, [countAllCartProducts()]);


	const [isLocationClicked, setIsLocationClicked] = useState(false);

	const navbarRef = useRef(null);

	const {
		setNavbarSearchQuery,
	} = useTestContext();

	// const calculateTotalPrice = useCallback(
	// 	async (orderDataToCalculate, promoCode) => {
	// 		try {
	// 			// Get the token and userId from cookies
	// 			const token = Cookies.get("token");
	// 			//const userId = Cookies.get("userId");

	// 			// Check if token exists
	// 			if (!token) {
	// 				throw new Error("User is not authenticated");
	// 			}

	// 			// Set the Authorization header with the token
	// 			const config = {
	// 				headers: {
	// 					Authorization: `Bearer ${token}`,
	// 				},
	// 			};

	// 			// Send POST request to calculate the total price
	// 			const response = await axios.post(
	// 				`${baseUrl}/api/cart/calculate-total-price`,
	// 				{ orderDataToCalculate, promoCode },
	// 				config
	// 			);

	// 			// Handle the response (display or use totalPrice)
	// 			if (response?.data?.success) {
	// 				setOrderSummary(response?.data);
	// 				console.log("1091 data", response?.data.extraDiscount);
	// 			} else {
	// 				console.error("Error:", response?.data?.message);
	// 			}
	// 		} catch (error) {
	// 			console.error("Error calculating total price:", error?.message);
	// 		}
	// 	},
	// 	[baseUrl]
	// );

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (navbarRef.current && !navbarRef.current.contains(event.target)) {
				setNavbarSearchQuery("");
				setIsLocationClicked(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const handleLocationClick = () => {
		alert(
			" Location permission denied.\n\n" +
			" Please enable location access manually:\n" +
			"- Click the lock icon 🔒 in the address bar\n" +
			"- Set Location to Allow\n" +
			"- Reload the page"
		);
	};

	useEffect(() => {
		if (orderSummary?.success) {
			// console.log("hello line 681", orderSummary.extraDiscount);
		}
	}, [orderSummary]);

	// useEffect(() => {
	// 	console.log("🔥 Payment details updated:", order?.paymentDetails);
	// }, [order?.paymentDetails]);





	return (
		<>
			{isAuth && <AuthComponent />}
			{countAllCartProducts() === 0 && (
				<div className='w-screen h-screen bg-secondaryColor flex flex-col justify-start items-center pt-[17.5%] lg:pt-[6%] pb-[1%] px-[3%]'>
					{/* <Navbar searchVisible={false} /> */}
					<Navbar locationCardVisibility={handleLocationClick} />
					<NavigationTracker endpoint='Cart' />
					<div className='w-full h-full flex justify-center items-center'>
						<p className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
							Cart is empty
						</p>
					</div>
				</div>
			)}
			{countAllCartProducts() > 0 && (
				<div className='w-screen h-screen bg-whiteColor flex flex-col justify-start items-center pt-[17.5%] lg:pt-[6%] pb-[1%] px-[3%] overflow-scroll scrollbar-hide'>
					<Navbar />
					{/* <Navbar locationCardVisibility={setIsLocationClicked} />  /<- this is not showing dropdown */}
					<Navbar locationCardVisibility={handleLocationClick} />
					<NavigationTracker endpoint='Cart' />
					<div className='w-full h-fit lg:px-[5.5%] space-y-[3%] lg:space-y-[1%]'>
						<div className='w-full lg:w-[68%] h-fit flex justify-between items-center'>
							<span className='font-medium text-[4.5vw] lg:text-[1.25vw] text-textPrimaryColor'>
								Who is being tested?
							</span>
							{order?.orderData?.length < 3 && (
								<button
									className='flex items-center space-x-2 lg:space-x-1 font-normal text-[3.5vw] lg:text-[0.8vw] text-accentColor'
									onClick={addANewMember}>
									<BiPlus className='text-[1.25vw]' />
									<span>Add Another Member</span>
								</button>
							)}
						</div>
						<div className='w-full h-fit flex flex-col lg:flex-row justify-start items-start space-y-[4%] lg:space-y-0 lg:space-x-[3%]'>
							{/* Left part */}
							<div className='w-full lg:w-[70%] h-fit flex flex-col justify-start items-center space-y-[4%] lg:space-y-[2.5%]'>
								{order?.orderData?.map((data, index) => (
									<div
										// this is outline of that model
										className='w-full h-fit bg-whiteColor border border-accentColor rounded-3xl p-[4%] lg:p-[2%] space-y-[5%]'
										key={index}>
										<div className='w-full h-fit flex justify-between items-center space-x-[2%]'>
											{data?.items?.length > 0 ? (
												<img
													src={
														data?.items[data?.items?.length - 1]?.product
															?.brandImg
													}
													alt='logo'
													className='w-[15%] lg:w-[7.5%] rounded-xl'
													loading='lazy'
												/>
											) : (
												<span className='font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor whitespace-nowrap'>
													No product available in cart
												</span>
											)}
											<div className='w-[92.5%] h-fit flex justify-between items-center'>
												{/* <span className='font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor'> */}
												{/* Brand name text with black color */}
												<span className='font-medium text-[3vw] lg:text-[1vw] text-textPrimaryColor'>
													{
														data?.items[data?.items?.length - 1]?.product
															?.brandName
													}
												</span>

												{/* Patients */}
												{Object.keys(data?.patient ?? {}).length === 0 && (
													<button
														className='btn-primary'
														onClick={() => {
															setIndexToAddPatient(index);
															handleAddMemberPopup();
														}}>
														Add Member
													</button>
												)}

												{Object.keys(data?.patient ?? {}).length > 0 && (
													<div className='flex flex-col items-end'>
														<div
															className='flex items-center cursor-pointer'
															onClick={() => removePatientAtIndex(index)}>
															<span className='font-normal text-[3.5vw] lg:text-[0.9vw] text-primaryColor mr-2'>
																{data?.patient?.name}
															</span>
															<span className='font-normal text-[3.5vw] lg:text-[0.9vw] text-primaryColor mr-1 hidden lg:block'>
																{calculateAge(data?.patient?.dob)}
															</span>
															<span className='font-normal text-[3.5vw] lg:text-[0.9vw] text-primaryColor mr-2 hidden lg:block'>
																{capitalizeFirstLetter(data?.patient?.gender)}
															</span>
															<IoIosCloseCircle className='font-normal text-[5vw] lg:text-[1.25vw] text-[#DB9A39]' />
														</div>
														{calculateAge(data?.patient?.dob) < 5 && (
															<p className='font-normal text-[3.25vw] lg:text-[0.8vw] text-[#DB9A39] cursor-pointer mt-[3%]'>
																No home collection for age below 5 years.
															</p>
														)}
													</div>
												)}
											</div>
										</div>


										{/* Products */}
										<div className='w-full h-fit flex flex-col justify-start items-center space-y-[1.5%] '>
											{/* {console.log("items", data?.items)} */}
											{data?.items?.map((item, idx) => (

												<div
													key={idx}
													className={`w-full h-fit ${item?.product?.productTitle?.length > 0
														? "flex"
														: "hidden"
														} justify-between items-center`}>
													{/* {console.log("product and item", item.product, item)} */}


													<div className='w-[90%] lg:w-[95%] h-fit flex justify-between items-center'>
														<div className='w-[75%] lg:w-[60%] h-fit flex justify-between items-center'>
															<span className='font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor'>
																{item?.product?.productTitle}
																{/* {console.log("item", item.product.productTitle)} */}
															</span>
															{item?.discountPercentage > 0 && (
																<span className='font-normal text-[3.5vw] lg:text-[0.8vw] text-whiteColor'>
																	<span className='bg-green-500 px-2 py-0.5 rounded-md whitespace-nowrap'>
																		{item?.discountPercentage} %
																	</span>
																</span>
															)}
														</div>
														{/* price tag */}


														



													
<div className='flex flex-col lg:flex-row lg:space-x-4'>

															{/** Check if current product is the matched free test */}
															{order?.appliedPromoCode === "FREETEST" &&
																item?.product?.productTitle?.trim()?.toLowerCase() ===
																order?.matchedFreeTest?.name?.trim()?.toLowerCase() &&
																item?.product?.brandName?.trim()?.toLowerCase() ===
																order?.matchedFreeTest?.brand?.trim()?.toLowerCase() ? (

																/** 🔥 SHOW FREE — only for matched free test */
																<span className="flex-1 font-medium text-[4vw] lg:text-[1vw] text-green-500 whitespace-nowrap">
																	FREE
																</span>

															) : (
																/** Normal paid product price */
																<div className='flex flex-col lg:flex-row lg:space-x-4'>
																	<span
																		className={`flex-1 font-medium text-[4vw] lg:text-[1vw] 
            															${order?.appliedPromoCode === "FREETEST" &&
																				item?.product?.productTitle?.trim()?.toLowerCase() ===
																				order?.matchedFreeTest?.name?.trim()?.toLowerCase() &&
																				item?.product?.brandName?.trim()?.toLowerCase() ===
																				order?.matchedFreeTest?.brand?.trim()?.toLowerCase()
																				? "text-green-500"
																				: item?.discountPrice > 0
																					? "line-through text-textSecondaryColor"
																					: "text-textPrimaryColor"
																			} 
            															whitespace-nowrap`}
																	>
																		{order?.appliedPromoCode === "FREETEST" &&
																			item?.product?.productTitle?.trim()?.toLowerCase() ===
																			order?.matchedFreeTest?.name?.trim()?.toLowerCase() &&
																			item?.product?.brandName?.trim()?.toLowerCase() ===
																			order?.matchedFreeTest?.brand?.trim()?.toLowerCase()
																			? (
																				"FREE"
																			) : (
																				<>
																					{item?.product?.currency} {item?.product?.sellingPrice}
																				</>
																			)
																		}
																	</span>

																	{item?.discountPrice > 0 && (
																		<span className='flex-1 font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor whitespace-nowrap'>
																			{item?.product?.currency} {item?.discountPrice}
																		</span>
																	)}
																</div>

															)}

														</div>
													</div>

													{/* delete button */}
													<button
														className='text-[5vw] lg:text-[1.25vw] text-[#DB9A39]'
														onClick={() => handleRemoveProductClick(index, idx)}
														disabled={isRemoving}>
														<img
															src='/assets/delete-icon.svg'
															alt='delete-icon'
														/>
													</button>
												</div>

											))}
										</div>
										<div className='w-full h-fit flex flex-col lg:flex-row justify-between items-center'>
											<button
												className='flex items-center space-x-2 lg:space-x-1 font-normal text-[3.5vw] lg:text-[0.8vw] text-accentColor'
												onClick={() => {
													setAddMoreTestIndex(index);
													navigate("/");
												}}>
												<BiPlus className='text-[5vw] lg:text-[1.25vw]' />
												<span>Add More Tests</span>
											</button>
										</div>
									</div>
								))}

								{/* ------------No Centres found for this city------------------- */}

								{Object.keys(order?.orderData[order?.orderData?.length - 1]?.patient ?? {}).length > 0 &&
									Object.keys(order?.address ?? {}).length > 0 && (
										<>
											{hasRadiology && (
												<p
													className={`font-normal text-[4vw] lg:text-[1vw] ${centreAvailable?.flag ? "text-green-500" : "text-red-500"
														} mt-[3%]`}
												>
													{centreAvailable?.flag
														? ""
														: "No centres found for this city and no home collection available."}
												</p>
											)}
										</>
									)
								}

								{/* ------------------------------------------------------------ */}
								{/* Collection date  center available */}
								{/* {console.log("order", order)} */}
								{Object.keys(
									order?.orderData[order?.orderData?.length - 1]?.patient ?? {}
								).length > 0 &&
									Object.keys(order?.address ?? {}).length > 0 &&
									(hasRadiology ? centreAvailable.flag : true) && (

										// <div className='w-full h-fit bg-whiteColor flex flex-col justify-start items-start border border-accentColor rounded-3xl p-[4%] lg:p-[2%]

										<div className='w-full h-auto flex flex-col justify-start items-start border border-accentColor rounded-3xl p-[4%] lg:p-[2%]'>
											{/*--------------------This div (Both button with border adjust)--------- */}
											<div className="w-full h-fit flex flex-col lg:flex-row lg:justify-start mb-[2%] relative">
												<div className="w-full flex flex-col lg:flex-row lg:items-center lg:justify-start">
													{/* Buttons container */}
													<div
														className={`${allCentres.length > 0
															? `${(hasRadiology && hasOtherThanRadiology && collectionType === "Home") ||
																(!hasRadiology && hasOtherThanRadiology)
																? "w-full sm:w-full md:w-[100%] lg:w-[50%]"
																: "w-full sm:w-full md:w-[100%] lg:w-[21.7%]"
															}
														h-fit relative flex justify-center md:justify-between items-center border-2 border-accentColor rounded-full`
															: "w-[90%] md:w-[60%] h-fit flex justify-center md:justify-between items-center rounded-full"
															}`}
													>
														{/* Home button */}
														{allCentres.length === 0 &&
															handleCollectionType("Home")}


														{/*--------------- radiology and non radiology so this home collection should be shown------------- */}
														{((hasRadiology && hasOtherThanRadiology && collectionType === "Home") ||
															(!hasRadiology && hasOtherThanRadiology)) && (
																<button
																	className={`${(hasRadiology && hasOtherThanRadiology
																		? cartCollectionType === "Home"
																		: collectionType === "Home")
																		? "bg-gradient-to-r from-[#0047AF] to-[#1A67D8] text-whiteColor"  //bg gradient goes to right to left color: respectively 
																		: "bg-whiteColor text-textSecondaryColor"   //if home collection is not select so bg color should be white 
																		// above 2 line for selection of color that if selected that button do this and not selected do this....
																		} px-[8.5%] py-[3.5%] lg:py-[1.5%] rounded-full font-normal text-[3vw] lg:text-[1vw] whitespace-nowrap w-full md:w-auto  md:mb-0`}
																	onClick={() => {
																		serviceableArea?.flag &&
																			(hasRadiology && hasOtherThanRadiology
																				? handleCartCollectionType("Home")
																				: handleCollectionType("Home"));
																	}}
																>
																	Home Collection
																</button>


															)}

														{/* Visit button (here the logic for only visit nearest center or with home button border logic and visit nearest center button logic */}
														{allCentres?.length > 0 && (
															<button
																// this class is for border only for Visit nearest center
																className={`${(hasRadiology && hasOtherThanRadiology
																	? cartCollectionType === "Visit"
																	: collectionType === "Visit")
																	? "bg-gradient-to-r from-[#0047AF] to-[#1A67D8] text-whiteColor"
																	: "bg-whiteColor text-textSecondaryColor"
																	} px-[7.5%] py-[3.5%] lg:py-[1.5%] rounded-full font-normal text-[3vw] lg:text-[1vw] whitespace-nowrap w-full`}
																onClick={() => {
																	setVisitClicked(true);
																	hasRadiology && hasOtherThanRadiology
																		? handleCartCollectionType("Visit")
																		: handleCollectionType("Visit");
																}}
															>
																Visit Nearest Center
															</button>

														)}
														{hasRadiology && !visitClicked && (
															<div className="absolute top-[20%] right-[4%]">
																<img src="/assets/dot-icon.svg" alt="" />
															</div>
														)}
													</div>

													{hasRadiology && hasOtherThanRadiology && (
														<div
															className="
														w-full flex justify-center mt-3
														md:mt-4   
														lg:w-auto lg:mt-0 lg:ml-36 lg:justify-start
														text-[16px] text-[#0047AF] cursor-pointer
													"
															onClick={handleChangeMethodClick}
														>
															<u>Change method</u>
														</div>
													)}
												</div>

												{collectionType === "Visit" && (
													<div className="font-normal lg:absolute right-2 top-0 text-[2.5vw] flex justify-center pt-2 lg:text-[0.8vw] text-textSecondaryColor">
														*Please note the address
													</div>
												)}

											</div>

											{/* Home Visit */}
											{brandNameInCart === "Metropolis Healthcare" ||
												brandNameInCart === "Redcliffe Labs" ||
												(hasRadiology && hasOtherThanRadiology
													? cartCollectionType === "Home"
													: collectionType === "Home") ? (
												<>
													{/* Save date */}
													<div className='w-full h-fit flex flex-wrap justify-center lg:justify-between items-center mb-[2%]'>
														{(brandNameInCart === "Redcliffe Labs" || brandNameInCart === "Metropolis Healthcare"
															? next7DaysArray.slice(0, 7)
															: next7DaysArray
														)?.map((date, index) => {
															const isCurrentDate =
																date?.day === currentDate?.day &&
																date?.dayName === currentDate?.dayName &&
																date?.month === currentDate?.month;

															const isNextDate =
																date?.day === nextDate?.day &&
																date?.dayName === nextDate?.dayName &&
																date?.month === nextDate?.month;

															return isCurrentDate ||
																(brandNameInCart === "Dr Lal PathLabs" &&
																	isNextDate) ? (

																<div
																	className="
																w-[70px] h-24 
																flex flex-col justify-center items-center 
																border border-accentColor/50 
																rounded-2xl shadow 
																px-[6%] py-[1.5%] 
																mr-[3%] lg:mr-0 
																mb-[3%] lg:mb-0
															"
																	key={index}
																>

																	<span className=' text-[4vw] md:text-[4vw] lg:text-[1vw] lg:text-base font-normal  text-textSecondaryColor'>
																		{date.month}
																	</span>
																	<span className='font-medium text-[3.5vw] md:text-base lg:text-[1.25vw] text-primaryColor'>
																		{date.day}
																	</span>
																	<span className='font-normal text-[2.5vw] md:text-sm lg:text-[1vw] text-textPrimaryColor'>
																		{date.dayName.toUpperCase()}
																	</span>

																</div>

															)

																// w-[70px] h-24 flex flex-col justify-center items-center border border-accentColor/50 rounded-2xl shadow px-[6%] py-[1.5%] mr-[3%] lg:mr-0 mb-[3%] lg:mb-0

																// hover:border-2 hover:border-primaryColor w-[70px] h-24 flex flex-col justify-center items-center border border-accentColor rounded-2xl shadow px-[6%] py-[1.5%] cursor-pointer mr-[3%] lg:mr-0 mb-[3%] lg:mb-0
																: (
																	// date box with hover light blue on date and day
																	<div
																		className={`${order?.collectionDate?.date?.day ===
																			date?.day &&
																			order?.collectionDate?.date?.dayName ===
																			date?.dayName &&
																			order?.collectionDate?.date?.month ===
																			date?.month
																			? "border-2 border-primaryColor"
																			: "hover:border-2 hover:border-primaryColor"
																			// } w-[70px] h-24 flex flex-col justify-center items-center border border-accentColor rounded-2xl shadow px-[6%] py-[1.5%] cursor-pointer mr-[3%] lg:mr-0 mb-[3%] lg:mb-0`}
																			} w-[70px] h-24 flex flex-col justify-center items-center border border-accentColor rounded-2xl shadow px-[6%] py-[1.5%] cursor-pointer mr-[3%] lg:mr-0 mb-[3%] lg:mb-0`}
																		//  w-[70px] h-24 flex flex-col justify-center items-center border border-accentColor/50 rounded-2xl shadow px-[6%] py-[1.5%] mr-[3%] lg:mr-0 mb-[3%] lg:mb-0

																		key={index}
																		onClick={() => saveCollectionDate(date)}
																	>


																		{validationError && (
																			<div className="text-red-500 text-sm mt-2">
																				{validationError}
																			</div>
																		)}

																		{/* <span className='font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor'>
																			{date.month}
																		</span>
																		
																		<span className='font-medium text-[3.5vw] md:text-base lg:text-[1.25vw] text-primaryColor'>
																			{date.day}
																		</span>
																		<span className='font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor'>
																			{date.dayName.toUpperCase()}
																		</span> */}

																		<span className=' text-[4vw] md:text-[4vw] lg:text-[1vw] lg:text-base font-normal  text-textSecondaryColor'>
																			{date.month}
																		</span>
																		<span className='font-medium text-[3.5vw] md:text-base lg:text-[1.25vw] text-primaryColor'>
																			{date.day}
																		</span>
																		<span className='font-normal text-[2.5vw] md:text-sm lg:text-[1vw] text-textPrimaryColor'>
																			{date.dayName.toUpperCase()}
																		</span>


																	</div>

																);
														})}
													</div>


													{/* Save time */}
													<div className='w-full h-fit flex flex-col justify-start items-start space-y-[4%] lg:space-y-[2%]'>
														{/* After radio buttons grid */}
														{hasRadiology && hasOtherThanRadiology && order?.collectionDate?.time && !order?.visitDate?.time && (
															<div className="text-red-500 text-sm mt-2">
																Please select visit nearest centre date and time for proceed to Payment
															</div>
														)}

														<span className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
															Preferred Time Slot
														</span>

														{order?.collectionDate?.date?.day ===
															currentDate?.day &&
															order?.collectionDate?.date?.dayName ===
															currentDate?.dayName &&
															order?.collectionDate?.date?.month ===
															currentDate?.month ? (
															<span className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor'></span>
														) : (
															<div className='w-full h-fit grid grid-cols-2 lg:grid-cols-4 gap-x-[2%] gap-y-3'>
																{slotsAreFull ? (
																	<div className='w-[300px] lg:w-[500px] text-red-500'>
																		All slots are full for this date. Please
																		select another date
																	</div>
																) : (
																	<>
																		{brandNameInCart === "Pathkind Labs" &&
																			pathkindLabsSlot.map((slot, index) => (
																				<div
																					key={index}
																					className='flex items-center space-x-3'
																					onClick={() =>
																						saveCollectionTime(slot)
																					}>
																					<input
																						type='radio'
																						id={`slot-${index}`}
																						name='slot'
																						value={slot}
																						checked={
																							order?.collectionDate?.time ===
																							slot
																						}
																						onChange={handleSlotChange}
																						className='w-4 h-4'
																					/>
																					<label
																						htmlFor={`slot-${index}`}
																						className='font-normal text-[3.2vw] lg:text-[1vw] text-textPrimaryColor'>
																						{slot}
																					</label>
																				</div>
																			))
																		}

																		{brandNameInCart === "Dr Lal PathLabs" &&
																			drLalPathlabsSlot.map((slot, index) => (
																				<div
																					key={index}
																					className='flex items-center space-x-3 '
																					onClick={() =>
																						saveCollectionTime(slot)
																					}>
																					<input
																						type='radio'
																						id={`slot-${index}`}
																						name='slot'
																						value={slot}
																						checked={
																							order?.collectionDate?.time ===
																							slot
																						}
																						onChange={handleSlotChange}
																						className='w-4 h-4 bg-[#0047AF]'
																					/>
																					<label
																						htmlFor={`slot-${index}`}
																						className='font-normal text-[3.2vw] lg:text-[1vw] text-textPrimaryColor'>
																						{slot}
																					</label>
																				</div>
																			))
																		}

																		{brandNameInCart === "Redcliffe Labs" &&
																			redcliffeeLabsSlot.map((slot, index) => (
																				<div
																					key={index}
																					className='flex items-center space-x-3'
																					onClick={() =>
																						saveCollectionTime(slot)
																					}>
																					<input
																						type='radio'
																						id={`slot-${index}`}
																						name='slot'
																						value={slot}
																						checked={
																							order?.collectionDate?.time ===
																							slot
																						}
																						onChange={handleSlotChange}
																						className='w-4 h-4'
																					/>
																					<label
																						htmlFor={`slot-${index}`}
																						className='font-normal text-[3.2vw] lg:text-[1vw] text-textPrimaryColor'>
																						{slot}
																					</label>
																				</div>
																			))}

																		{brandNameInCart === "Agilus Diagnostics" &&
																			AgilusSlot.map((slot, index) => (
																				<div
																					key={index}
																					className='flex items-center space-x-3'
																					onClick={() =>
																						saveCollectionTime(slot)
																					}>
																					<input
																						type='radio'
																						id={`slot-${index}`}
																						name='slot'
																						value={slot}
																						checked={
																							order?.collectionDate?.time ===
																							slot
																						}
																						onChange={handleSlotChange}
																						className='w-4 h-4'
																					/>
																					<label
																						htmlFor={`slot-${index}`}
																						className='font-normal text-[3.2vw] lg:text-[1vw] text-textPrimaryColor'>
																						{slot}
																					</label>
																				</div>
																			))}

																		{brandNameInCart ===
																			"Metropolis Healthcare" &&
																			metropolisSlot.map((slot, index) => (
																				<div
																					key={index}
																					className='flex items-center space-x-3'
																					onClick={() =>
																						saveCollectionTime(slot)
																					}>
																					<input
																						type='radio'
																						id={`slot-${index}`}
																						name='slot'
																						value={slot}
																						checked={
																							order?.collectionDate?.time ===
																							slot
																						}
																						onChange={handleSlotChange}
																						className='w-4 h-4'
																					/>
																					<label
																						htmlFor={`slot-${index}`}
																						className='font-normal text-[3.2vw] lg:text-[1vw] text-textPrimaryColor'>
																						{slot}
																					</label>
																				</div>
																			))}
																	</>
																)}
															</div>
														)}
													</div>
												</>
											) : null}
											{/* Visit Center */}
											{(hasRadiology && hasOtherThanRadiology
												? cartCollectionType === "Visit"
												: collectionType === "Visit") && (
													<>


														<div className='w-full h-fit mt-[5%] md:mt-0 flex flex-col justify-start items-start space-y-[1%] mb-[2%]'>
															{displayedCentres?.map((center, index) => (
																<div
																	className='flex items-center space-x-3'
																	key={index}
																	onClick={() => saveVisitCenter(center)}
																>
																	<input
																		type='radio'
																		id={`center-${index}`} // unique id
																		name='center'
																		value={center.address}
																		checked={order?.visitCenter === center?.address}
																		onChange={handleVisitCenterChange}
																		className='w-4 h-4'
																	/>
																	<label
																		htmlFor={`center-${index}`} // match id
																		className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor'
																	>
																		{center?.address}
																	</label>
																</div>
															))}

															{/* Show More / Less Button */}
															{allCentres.length > 5 && (
																<span
																	className='text-blue-500 cursor-pointer mt-2 text-[3.5vw] lg:text-[0.9vw]'
																	onClick={() => setShowAll(prev => !prev)}
																>
																	{showAll ? 'See Less' : 'See More'}
																</span>
															)}
														</div>


														{/* Save date */}

														<div className="w-full h-fit flex flex-wrap justify-center lg:justify-between items-center gap-3 mb-[2%]">
															{next7DaysArray?.map((date, index) => {
																const isCurrentDate =
																	date?.day === currentDate?.day &&
																	date?.dayName === currentDate?.dayName &&
																	date?.month === currentDate?.month;

																const isSelected =
																	order?.visitDate?.date?.day === date?.day &&
																	order?.visitDate?.date?.dayName === date?.dayName &&
																	order?.visitDate?.date?.month === date?.month;

																return (
																	<div
																		key={index}
																		onClick={() => !isCurrentDate && saveVisitDate(date)}
																		className={`
																	flex flex-col justify-center items-center
																	min-w-[60px] sm:min-w-[70px] md:min-w-[80px]
																	h-24 border rounded-2xl shadow px-2 py-1 cursor-pointer
																	${isCurrentDate
																				? "border-accentColor/50"
																				: isSelected
																					? "border-2 border-primaryColor"
																					: "border border-accentColor hover:border-2 hover:border-primaryColor"}
																	`}
																	>
																		<span className="font-normal text-xs sm:text-sm md:text-base text-textSecondaryColor">
																			{date.month}
																		</span>
																		<span className="font-medium text-sm sm:text-lg md:text-xl text-primaryColor">
																			{date.day}
																		</span>
																		<span className="font-normal text-xs sm:text-sm md:text-base text-textSecondaryColor">
																			{date.dayName.toUpperCase()}
																		</span>
																	</div>
																);
															})}
														</div>

														{/* Save time */}
														<div className='w-full h-fit flex flex-col justify-start items-start space-y-[4%] lg:space-y-[2%]'>
															<span className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
																Preferred Time Slot
															</span>
															{order?.visitDate?.date?.day === currentDate?.day &&
																order?.visitDate?.date?.dayName ===
																currentDate?.dayName &&
																order?.visitDate?.date?.month ===
																currentDate?.month ? (
																<span className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor'></span>
															) : (
																<div className='w-full h-fit grid grid-cols-2 lg:grid-cols-4 gap-x-[5%] gap-y-3'>
																	{visitCentreSlot.map((slot, index) => (
																		<div
																			key={index}
																			className='flex items-center space-x-3'
																			onClick={() => saveVisitTime(slot)}>
																			<input
																				type='radio'
																				id={`slot-${index}`}
																				name='slot'
																				value={slot}
																				checked={order?.visitDate?.time === slot}
																				onChange={handleSlotChange}
																				className='w-4 h-4'
																			/>
																			<label
																				htmlFor={`slot-${index}`}
																				className='font-normal text-[3.2vw] lg:text-[1vw] text-textPrimaryColor whitespace-nowrap'>
																				{slot}
																			</label>
																		</div>
																	))}
																</div>
															)}
														</div>
													</>
												)}

										</div>

									)}

								{/* ----------This can be work for dr lal when data (address) is not showing--------------- */}

								{/* {Object.keys(order?.orderData[order?.orderData?.length - 1]?.patient ?? {}).length > 0 &&
									Object.keys(order?.address ?? {}).length > 0 ? (
										hasRadiology ? (
										centreAvailable?.flag ? (
											<div>Data is available</div>
										) : (
											<div>No data available</div>
										)
										) : null
									) : (
										<div>No data available</div>
									)} */}
								{/* ----------------------------------------------------- */}

								{(() => {
									const hasPatient =
										Object.keys(order?.orderData?.[order?.orderData?.length - 1]?.patient ?? {})
											.length > 0;
									const hasAddress = Object.keys(order?.address ?? {}).length > 0;

									if (hasPatient && hasAddress) {
									} else if (!hasPatient && !hasAddress) {
										//Both missing
										return <div>Please add member and select address</div>;
									} else if (!hasPatient) {
										//Patient missing only
										return <div>Please add family member </div>;
									} else if (!hasAddress) {
										//Address missing only
										return <div>Please select the address</div>;
									}
								})()}

							</div>

							{/* Right part */}
							<div className='w-full lg:w-[30%] h-fit flex flex-col justify-start items-center space-y-[4%] lg:space-y-[5%]'>
								{/* If no address */}
								{Object.keys(
									order?.orderData[order?.orderData?.length - 1]?.patient ?? {}
								).length > 0 &&
									Object.keys(order?.address ?? {}).length === 0 && (
										<button
											className='w-[90%] btn-primary'
											onClick={handleAddAddressPopup}>
											Select Address
										</button>
									)}

								{/* If address */}
								{Object.keys(
									order?.orderData[order?.orderData?.length - 1]?.patient ?? {}
								).length > 0 &&
									Object.keys(order?.address ?? {}).length > 0 && (
										// ---------------------------Select address box------------------------
										<div className='w-full h-fit bg-whiteColor flex flex-col justify-start items-start border border-accentColor rounded-3xl p-[5%]'>
											<span className='font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor mb-[1%]'>
												Selected Address
											</span>
											<div className='w-full h-full flex justify-end items-center mb-[2%]'>
												<button
													className='text-[5vw] lg:text-[1.25vw] text-[#DB9A39]'
													onClick={removeAddress}>
													<img
														src='/assets/delete-icon.svg'
														alt='delete-icon'
													/>
												</button>
											</div>
											<p className='font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor'>
												{order?.address?.house}, {order?.address?.area},{" "}
												{order?.address?.city}, {order?.address?.state} -{" "}
												{order?.address?.pincode}
											</p>
											{serviceableArea?.message?.length > 0 && (
												<p
													className={`font-normal text-[4vw] lg:text-[1vw] ${serviceableArea?.flag
														? "text-green-500"
														: "text-red-500"
														} mt-[3%]`}>
													{serviceableArea?.flag
														? ""
														: serviceableArea?.message}
												</p>
											)}

											{centreAvailable?.message?.length > 0 && hasRadiology && (
												<p
													className={`font-normal text-[4vw] lg:text-[1vw] ${centreAvailable?.flag
														? "text-green-500"
														: "text-red-500"
														} mt-[3%]`}>
													{centreAvailable?.flag
														? ""
														: centreAvailable?.message}
												</p>
											)}
											{userLocationAddress === "" && (
												<p
													ref={gpsRef}
													className='font-normal bg-[#E6E6E6] rounded-[12px] p-4 text-[3.25vw] lg:text-[0.8vw] text-[#DB9A39] cursor-pointer mt-[3%]'
													onClick={saveCurrentLocation}>
													For on-time home collection, Please allow GPS or{" "}
													<b>click here</b>
												</p>
											)}
										</div>
									)}

								{(Object.keys(order?.address ?? {}).length > 0 &&
									Object.keys(
										order?.orderData[order?.orderData?.length - 1]?.patient ??
										{}
									).length > 0 &&
									order?.collectionDate?.date?.day &&
									order?.collectionDate?.date?.dayName?.length > 0 &&
									order?.collectionDate?.date?.month?.length > 0 &&
									order?.collectionDate?.time?.length > 0) ||
									order?.visitCenter?.length > 0 ? (
									<div className='w-full h-fit bg-whiteColor flex flex-col justify-start items-start border border-accentColor rounded-3xl p-[5%] space-y-[5%]'>
										<p className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
											<span className='text-green-500'>Save more</span> on this
											order
										</p>
										{order?.appliedPromoCode?.length === 0 && (
											<div
												className='w-full h-fit bg-secondaryColor flex justify-between items-center border border-accentColor rounded-xl p-[3%] cursor-pointer'
												onClick={handlePromoCodePopup}>
												<span className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor'>
													View all promocodes
												</span>
												<IoIosArrowDroprightCircle className='text-[6vw] lg:text-[1.75vw] text-primaryColor' />
											</div>
										)}
										{order?.appliedPromoCode?.length > 0 && (
											<div className='w-full h-fit flex flex-col justify-start items-start bg-secondaryColor rounded-xl p-[5%] space-y-[3%]'>
												<div className='w-full h-fit flex justify-between items-center'>
													<p className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textPrimaryColor'>
														<b>{order?.appliedPromoCode}</b> applied
													</p>
													<button
														className='font-normal text-[4vw] lg:text-[1vw] text-[#DB9A39] underline'
														onClick={removePromoCode}>
														Remove
													</button>
												</div>
												{order?.appliedPromoCode === "FREEHOME" ? (
													<p className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor'>
														{order?.paymentDetails?.currency} 100 Savings with
														this promocode
													</p>
												)
													:
													order?.appliedPromoCode === "FREETEST" ? (
														// <p className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor'>
														// 	{order?.paymentDetails?.freeTestsTotalMRP} Savings with
														// 	this promocode
														// </p>

														<div className="flex items-center gap-1">
															<span className="font-normal text-[4vw] lg:text-[1vw] text-green-500">
																FREE
															</span>
															<p className="font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor">
																🎉 You've got a free test
															</p>
														</div>


													) : (
														<p className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor'>
															{order?.paymentDetails?.currency}{" "}
															{order?.paymentDetails?.discount} Savings with this
															promocode
														</p>
													)
													//  (
													// 	<p className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor'>
													// 		{order?.paymentDetails?.currency}{" "}
													// 		{order?.paymentDetails?.discount} Savings with this
													// 		promocode
													// 	</p>
													// )

												}
												{/* {order?.appliedPromoCode==="FREETEST"?(
													<p className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor'>
														{order?.paymentDetails?.freeTestsTotalMRP} Savings with
														this promocode
													</p>
												):(
													<p className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor'>
														{order?.paymentDetails?.currency}{" "}
														{order?.paymentDetails?.discount} Savings with this
														promocode
													</p>
												)
												} */}
											</div>
										)}
									</div>
								) : null}

								{/* <div className='w-full h-fit bg-whiteColor flex flex-col justify-start items-start border border-accentColor rounded-3xl p-[5%]'>
									<span className='font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor mb-[5%]'>
										Order Summary
									</span>
									<div className='w-full h-fit flex justify-between items-center'>
										<span className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
											Total MRP
										</span>
										<span className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
											{order?.paymentDetails?.currency}{" "}
											{order?.paymentDetails?.totalPrice}
										</span>
									</div>
									{order?.paymentDetails?.totalPrice !==
										order?.paymentDetails?.discount && (
											<div className='w-full h-fit flex justify-between items-center mt-[3%]'>
												<span className='font-normal text-[4vw] lg:text-[1vw] text-green-500'>
													Discount
												</span>
												<span className='font-normal text-[4vw] lg:text-[1vw] text-green-500'>
													- {order?.paymentDetails?.currency}{" "}
													{order?.paymentDetails?.discount}
												</span>
											</div>
										)}
									<div className='w-full h-fit flex justify-end items-center mb-[5%]'>
										<span className='font-normal text-[3vw] lg:text-[0.75vw] text-textSecondaryColor hidden'>
											Flat 20% off
										</span>
									</div>
									<div className='w-full h-fit flex justify-between items-center mb-[5%]'>
										<span className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
											Collection Charges
										</span>
										<span className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
											{order?.paymentDetails?.collectionCharges === "0.00" ? (
												<>
													<span className='line-through'>
														{order?.paymentDetails?.currency}{" "}
														{order?.paymentDetails?.platformFee}
													</span>{" "}
													<span>Free</span>
												</>
											) : (
												<>
													{order?.paymentDetails?.currency}{" "}
													{order?.paymentDetails?.collectionCharges}
												</>
											)}
										</span>
									</div>
									<div className='w-full h-fit flex justify-between items-center mb-[5%]'>
										<span className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
											Platform Fee
										</span>
										<span className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
											<span className='line-through'>
												{order?.paymentDetails?.currency}{" "}
												{order?.paymentDetails?.platformFee}
											</span>{" "}
											<span>Free</span>
										</span>
									</div>
									<div className='w-full h-fit flex justify-between items-center mb-[5%]'>
										<span className='font-medium text-[4vw] lg:text-[1vw] text-primaryColor'>
											To Pay
										</span>
										<span className='font-medium text-[4vw] lg:text-[1vw] text-primaryColor'>
											{order?.paymentDetails?.currency}{" "}
											{order?.paymentDetails?.finalAmount}
										</span>
									</div>
									{parseFloat(order?.paymentDetails?.freeChargeDifference) >
										0 && (
											<p className='font-normal text-[3.5vw] lg:text-[0.8vw] text-green-500'>
												Add item worth {order?.paymentDetails?.currency}{" "}
												{order?.paymentDetails?.freeChargeDifference} to unlock
												free delivery
											</p>
										)}

									{isValidOrder &&
										(order.orderData[0].items[0].product.brandName ===
											"Dr Lal PathLabs"
											? centreAvailable.flag
											: true) ? (
										<div className='w-full h-fit flex justify-center items-center mt-[5%]'>
											<button
												// disabled={!isProceedEnabled || isLoading}
												className={`bg-gradient-to-r from-[#0047AF] to-[#1A67D8] rounded-3xl font-normal text-[15px] text-whiteColor py-3 transition-all duration-500 ease-in-out
													${isLoading
														? "w-12 h-12 opacity-70 rounded-full p-0"
														: "w-full opacity-100"
													}`}
												onClick={handleProceedToPaymentClick}>
												{isLoading ? (
													<div className='flex items-center justify-center w-full h-full'>
														<div className='w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin'></div>
													</div>
												) : (
													"Proceed to Pay"
												)}
											</button>

										</div>
									) : (
										// this is for order summary small box
										<div className='w-full h-fit flex justify-end items-center mt-[5%] '>
											<button className='sm:w-full sm:h-16 lg:w-full lg:h-10 md:h-16 md:w-full btn-secondary md:justify-center'>
												Proceed to Pay
											</button>
										</div>
									)}
								</div> */}

								<div className='w-full h-fit bg-whiteColor flex flex-col justify-start items-start border border-accentColor rounded-3xl p-[5%]'>
									<span className='font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor mb-[5%]'>
										Order Summary
									</span>

									{/* Total MRP */}
									<div className='w-full h-fit flex justify-between items-center'>
										<span className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
											Total MRP
										</span>
										<span className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
											{order?.paymentDetails?.currency}{" "}
											{order?.paymentDetails?.totalPrice}
											{/* {order?.paymentDetails?.totalCartValue} */}
										</span>
										{/* {console.log("total cart value:", order?.paymentDetails?.totalCartValue)}
										{console.log("total Price:", order?.paymentDetails?.totalPrice)} */}
									</div>

									{/* Normal Discount
									{order?.paymentDetails?.totalPrice !== order?.paymentDetails?.discount && (
										<div className='w-full h-fit flex justify-between items-center mt-[3%]'>
											<span className='font-normal text-[4vw] lg:text-[1vw] text-green-500'>
												Discount
											</span>
											<span className='font-normal text-[4vw] lg:text-[1vw] text-green-500'>
												- {order?.paymentDetails?.currency}{" "}
												{order?.paymentDetails?.discount}
												{console.log("discount:", order?.paymentDetails?.discount)}
											</span>
										</div>
									)} */}

									{/* Normal Discount */}
{order?.paymentDetails?.totalPrice !== order?.paymentDetails?.discount &&
 order?.paymentDetails?.discount >= 100 && (
  <div className="w-full h-fit flex justify-between items-center mt-[3%]">
    <span className="font-normal text-[4vw] lg:text-[1vw] text-green-500">
      Discount
    </span>
    <span className="font-normal text-[4vw] lg:text-[1vw] text-green-500">
      - {order?.paymentDetails?.currency}{" "}
      {order?.paymentDetails?.discount}
    </span>
  </div>
)}



									{order?.paymentDetails?.freeTestsTotalMRP > 0 && (
										<div className='w-full h-fit flex justify-between items-center mt-[3%]'>
											<span className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
												Free test
											</span>
											<span className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
												{/* {order?.paymentDetails?.currency} {order?.paymentDetails?.freeTestsTotalMRP} */}
												0.00
											</span>
										</div>
									)}
									

									{/* <div className='w-full h-fit flex justify-between items-center mt-[3%]'>
										<span className='font-normal text-[4vw] lg:text-[1vw] text-green-500'>
											Extra Discount
										</span>
										<span className='font-normal text-[4vw] lg:text-[1vw] text-green-500'>
											- {order?.paymentDetails?.currency}{" "}
											{order?.paymentDetails?.extraDiscount}
										</span>
									</div> */}
									<div className='w-full h-fit flex justify-end items-center mb-[5%]'>
										<span className='font-normal text-[3vw] lg:text-[0.75vw] text-textSecondaryColor hidden'>
											Flat 20% off
										</span>
									</div>

									{/* Collection Charges */}
									<div className='w-full h-fit flex justify-between items-center mb-[5%]'>
										<span className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
											Collection Charges
										</span>
										<span className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
											{order?.paymentDetails?.collectionCharges === "0.00" ? (
												<>
													<span className='line-through'>
														{order?.paymentDetails?.currency}{" "}
														{order?.paymentDetails?.platformFee}
													</span>{" "}
													<span>Free</span>
												</>
											) : (
												<>
													{order?.paymentDetails?.currency}{" "}
													{order?.paymentDetails?.collectionCharges}
												</>
											)}
										</span>
									</div>

									{/* Platform Fee */}
									<div className='w-full h-fit flex justify-between items-center mb-[5%]'>
										<span className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
											Platform Fee
										</span>
										<span className='font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor'>
											<span className='line-through'>
												{order?.paymentDetails?.currency}{" "}
												{order?.paymentDetails?.platformFee}
											</span>{" "}
											<span>Free</span>
										</span>
									</div>

									{/* Final Amount */}
									<div className='w-full h-fit flex justify-between items-center mb-[5%]'>
										<span className='font-medium text-[4vw] lg:text-[1vw] text-primaryColor'>
											To Pay
										</span>
										<span className='font-medium text-[4vw] lg:text-[1vw] text-primaryColor'>
											{order?.paymentDetails?.currency}{" "}
											{order?.paymentDetails?.finalAmount}
										</span>
									</div>

									{/* Free delivery tip */}
									{parseFloat(order?.paymentDetails?.freeChargeDifference) > 0 && (
										<p className='font-normal text-[3.5vw] lg:text-[0.8vw] text-green-500'>
											Add item worth {order?.paymentDetails?.currency}{" "}
											{order?.paymentDetails?.freeChargeDifference} to unlock
											free delivery
										</p>
									)}


									{/* Proceed to Pay Button */}
									{isValidOrder &&
										(order.orderData[0].items[0].product.brandName === "Dr Lal PathLabs"
											? centreAvailable.flag
											: true) ? (
										<div className='w-full h-fit flex justify-center items-center mt-[5%]'>
											<button
												className={`bg-gradient-to-r from-[#0047AF] to-[#1A67D8] rounded-3xl font-normal text-[15px] text-whiteColor py-3 transition-all duration-500 ease-in-out
					${isLoading ? "w-12 h-12 opacity-70 rounded-full p-0" : "w-full opacity-100"}`}
												onClick={handleProceedToPaymentClick}>
												{isLoading ? (
													<div className='flex items-center justify-center w-full h-full'>
														<div className='w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin'></div>
													</div>
												) : (
													"Proceed to Pay"
												)}
											</button>
										</div>
									) : (
										<div className='w-full h-fit flex justify-end items-center mt-[5%] '>
											<button className='sm:w-full sm:h-16 lg:w-full lg:h-10 md:h-16 md:w-full btn-secondary md:justify-center'>
												Proceed to Pay
											</button>
										</div>
									)}
								</div>

							</div>
						</div>
					</div>
				</div >
			)}

			{
				isAddMemberPopup && (
					<AddMemberPopup closeButton={handleAddMemberPopup} />
				)
			}

			{
				isAddAddressPopup && (
					<AddAddressPopup closeButton={handleAddAddressPopup} />
				)
			}
			{isPromoCode && <PromoCodePopup />}
			{notificationData?.message?.length > 0 && <Notification />}

			{
				hasRadiology && hasOtherThanRadiology && isCollectionMethodPopup && (
					<CollectionMethodPopup products={allProductsInCart} />
				)
			}
		</>
	);
};

export default Cart;